import { useSiteStatusStore } from '~/stores/site-status';

// Aviso regulatório (Medida Provisória): com os depósitos desligados no core
// (Operações do site, ENG-915), o modal de depósito vira um aviso de "Depósitos
// suspensos" — sem formulário, sem métodos e sem o auto-submit do deeplink
// ?open=pix&value=.
//
// O bloqueio é só visual: /wallet/add-credit continua indo pro backend, que
// precisa aplicar o bloqueio de verdade.
//
// Os textos abaixo são o PADRÃO: o core pode sobrepor campo a campo (ver
// getSuspensionNotice). Campo não editado lá continua com a frase daqui.
export const depositSuspensionNotice = {
  title: 'Depósitos suspensos',
  message:
    'Em cumprimento à nova Medida Provisória, não estamos mais aceitando depósitos nem apostas. Os saques continuam disponíveis até as 23h59 do dia 5/10.',
  reassurance: 'Fique tranquilo: seu saldo está seguro na ApostaTudo.',
  dismissLabel: 'Entendi',
} as const;

export function isDepositSuspended(): boolean {
  return !useSiteStatusStore().status.depositsEnabled;
}

// Textos que o StepSuspended renderiza. O aviso de depósito acima já tem esse
// formato; os da pausa do site (abaixo) reusam o mesmo visual.
export type SuspensionNotice = {
  title: string;
  message: string;
  reassurance: string;
  dismissLabel: string;
};

export type SiteSuspensionVariant = 'home' | 'register' | 'games';

const SITE_SUSPENSION_REASSURANCE =
  'Fique tranquilo: seu saldo está seguro. Os saques e o suporte continuam funcionando normalmente.';

// Pausa das operações (Medida Provisória), aberta pelo AnnouncementModal: na
// home, no cadastro e em /games e /sports. Check-in e roletinha não passam por
// aqui: desligados no Clube Fidelidade, mostram o estado do próprio modal.
// O depósito continua no aviso do próprio modal de depósito
// (depositSuspensionNotice).
export const siteSuspensionNotices: Record<
  SiteSuspensionVariant,
  SuspensionNotice
> = {
  home: {
    title: 'Operações pausadas',
    message:
      'Em cumprimento à nova Medida Provisória, a ApostaTudo pausou temporariamente suas operações.',
    reassurance: SITE_SUSPENSION_REASSURANCE,
    dismissLabel: 'Entendi',
  },
  register: {
    title: 'Cadastros pausados',
    message:
      'Em cumprimento à nova Medida Provisória, não estamos aceitando novos cadastros no momento.',
    reassurance:
      'Já é cliente? Seu saldo está seguro. Os saques e o suporte continuam funcionando normalmente.',
    dismissLabel: 'Entendi',
  },
  games: {
    title: 'Apostas pausadas',
    message:
      'Em cumprimento à nova Medida Provisória, as apostas e os jogos estão temporariamente pausados.',
    reassurance: SITE_SUSPENSION_REASSURANCE,
    dismissLabel: 'Entendi',
  },
};

export type SuspensionVariant = SiteSuspensionVariant | 'deposit';

// O aviso que aparece no site: o texto editado no core onde houver, e a frase
// padrão daqui no resto. Reativo ao store, então um texto trocado no core
// atualiza o aviso aberto no próximo refresh do status.
export function getSuspensionNotice(
  variant: SuspensionVariant,
): SuspensionNotice {
  const defaults =
    variant === 'deposit'
      ? depositSuspensionNotice
      : siteSuspensionNotices[variant];

  const edited = useSiteStatusStore().status.notices[variant] ?? {};

  return {
    title: edited.title || defaults.title,
    message: edited.message || defaults.message,
    reassurance: edited.reassurance || defaults.reassurance,
    dismissLabel: edited.dismissLabel || defaults.dismissLabel,
  };
}
